import api from '../../api/index.js'

const state = {
    accessToken: {
        token: "",
        OpenId: "",
        expires: ""
    },
    isLogin: false,
    member: {}
}

const getters = {
    currentUser: state => {
        var data = {
            token: state.accessToken.token,
            openId: state.accessToken.openId,
            expires: state.accessToken.expires,
            member: state.member,
            isLogin: state.isLogin
        };

        var accessToken=JSON.parse(localStorage.getItem("accessToken"));
        if (accessToken != null) {
            var _member=JSON.parse(localStorage.getItem("member"));
            Object.assign(data, {
                token: accessToken.access_token,
                expires: accessToken.expires,
                member:_member,
                isLogin: true
            });
        }

        return data;
    }
}

const actions = {
    RegiestOrdinary({commit},payload)
    {
        return new Promise((resolve, reject) => {
            api.post('/Account/RegiestOrdinary',payload, res => {
                commit({
                    type: "setResultState",
                    res: res,
                })
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    RegestCarShare({commit},payload)
    {
        return new Promise((resolve, reject) => {
            api.post('/Account/RegestCarShare',payload, res => {
                commit({
                    type: "setResultState",
                    res: res,
                })
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    Login({commit}, payload) {        
        return new Promise((resolve, reject) => {
            api.post('/Account/LoginWeb',payload, res => {
                commit({
                    type: "setAccessToken",
                    res: res,
                })
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    AutoLogin({commit},payload){
        return new Promise((resolve, reject) => {
            api.post('/Account/AutoLogin',payload, res => {
                commit({
                    type: "setAccessToken",
                    res: res,
                })
                resolve(res)
            }, err => {
                reject(err)
            })
        })

    },
    Regiest({commit}, payload) {        
        return new Promise((resolve, reject) => {
            api.post('/Account/RegisterPhone',payload, res => {
                commit({
                    type: "setAccessToken",
                    res: res,
                })
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    UpdaeMemberPassword({commit}, payload) {
        return new Promise((resolve, reject) => {
            api.post('/Account/UpdaeMemberPassword',payload, res => {
                if (res.IsSuccess){
                    commit({
                        type: "setLogout",
                        res: res,
                    })                    
                }
                resolve(res);
            }, err => {
                reject(err)
            })
        })
    },
    UpdaeMemberPhone({commit}, payload) {
        return new Promise((resolve, reject) => {
            api.post('/Account/UpdaeMemberPhone',payload, res => {
                if (res.IsSuccess){
                    commit({
                        type: "setMember",
                        res: res,
                    })                    
                }
                resolve(res);
            }, err => {
                reject(err)
            })
        })
    },
    Logout({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit({
                type: "setLogout"
            })
            resolve();
        })
    },
    SendSmsCode({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/Account/SendSmsCode',payload, res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    SendRegisterSmsCode({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/Account/SendRegisterSmsCode',payload, res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    ChangePhone({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/Account/ChangePhone',payload, res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    ChangeNickName({commit},payload){
        return new Promise((resolve, reject) => {
            api.post('/Account/ChangeNickName',payload, res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    FindPwd({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/Account/FindPwd',payload, res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    SendSmsNewCode({commit},payload){
        return new Promise((resolve, reject) => {
            api.post('/Account/SendSmsNewCode',payload, res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    }
}

const mutations = {
    setAccessToken(state, payload) {
        //console.log(payload);
        //alert(JSON.stringify(payload.res.result))
        if(payload.res.result.status) {
            localStorage.setItem("token",payload.res.result.data.token);
            localStorage.setItem("member",JSON.stringify(payload.res.result.data.member));
            // localStorage.setItem("accessToken",JSON.stringify(payload.res.AccessToken));
            // localStorage.setItem("member",JSON.stringify(payload.res.Member));
            //alert(localStorage.getItem("token"));
            state.isLogin = true;
        }
    },
    setLogout(state, payload) {
        localStorage.removeItem("token");
        // localStorage.removeItem("accessToken");
        localStorage.removeItem("member");
        state.isLogin = false;
    },
    setMember(state, payload) {
        if(payload.res.result.status) {
            localStorage.removeItem("member");
            localStorage.setItem("member",JSON.stringify(payload.res.result.data.member));
        }
    },
    updateMember(state,payload)
    {
        localStorage.removeItem("member");
        localStorage.setItem("member",JSON.stringify(payload.data));
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js